import { render } from "./WithdrawalsTable.vue?vue&type=template&id=52521ae2&scoped=true&ts=true"
import script from "./WithdrawalsTable.vue?vue&type=script&lang=ts"
export * from "./WithdrawalsTable.vue?vue&type=script&lang=ts"

import "./WithdrawalsTable.vue?vue&type=style&index=0&id=52521ae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52521ae2"]])

export default __exports__